import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

interface ExamProcessingResult {
  success: boolean;
  data?: any;
  error?: string;
}

export async function examAIExtraction(
  fileBase64: string
): Promise<ExamProcessingResult> {
  try {
    const base64Response = await fetch(fileBase64);
    const blob = await base64Response.blob();

    const endpoint = `${import.meta.env.VITE_ENDPOINT_N8N}/extrair-analitos`;
    const response = await useAxios.post(endpoint, blob, {
      headers: {
        Authorization: await useAuth.getUserToken(),
        "Content-Type": "application/pdf",
      },
    });

    if (response.status !== HTTPResponseStatus.Success) {
      throw new Error(`Erro no processamento: ${response.status}`);
    }

    const result = response.data;
    const cleanResponseJson = result.output
      .replace(/```json\s*|```/g, "")
      .trim();

    try {
      const responseJson = JSON.parse(cleanResponseJson);
      return {
        success: true,
        data: responseJson,
      };
    } catch (error) {
      return {
        success: true,
        data: cleanResponseJson,
      };
    }
  } catch (error) {
    console.error("Erro ao processar exame com IA:", error);
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "Erro desconhecido ao processar com IA",
    };
  }
}
